/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_Signals_Check_WarningInputs */

const en_directory_detail_signals_check_warning = /** @type {(inputs: Directory_Detail_Signals_Check_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} partial`)
};

const zh_directory_detail_signals_check_warning = /** @type {(inputs: Directory_Detail_Signals_Check_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 项部分通过`)
};

/**
* | output |
* | --- |
* | "{count} partial" |
*
* @param {Directory_Detail_Signals_Check_WarningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_check_warning = /** @type {((inputs: Directory_Detail_Signals_Check_WarningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Check_WarningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_check_warning(inputs)
	return zh_directory_detail_signals_check_warning(inputs)
});
export { directory_detail_signals_check_warning as "directory.detail.signals.check_warning" }